/* Scroll-reveal for Sharq London: adds .is-visible as sections enter the viewport. */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '.shopify-section:not(.header-section):not([id*="footer"]) .section > *, .product-grid__item, .resource-list__item, .collection-card';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.01, rootMargin: '0px 0px -4% 0px' });
  function init() {
    document.querySelectorAll(sel).forEach(function (el, i) {
      if (el.closest('slideshow-component, .header-section, marquee-component, announcement-bar-component')) return;
      if (el.offsetHeight > window.innerHeight * 1.1 || el.matches('.collection-wrapper')) return; // very tall wrappers: let children animate instead
      el.style.setProperty('--sharq-i', i % 6);
      el.classList.add('sharq-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== Wishlist (stored in the visitor's browser) + hover actions on product cards ===== */
(function () {
  var KEY = 'sharq_wishlist';
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var T = AR
    ? { add: 'أضيفي إلى المفضلة', remove: 'إزالة من المفضلة', wishlist: 'المفضلة', empty: 'قائمة المفضلة فارغة. اضغطي على القلب في أي منتج لحفظه هنا.', shop: 'تسوقي الآن', cart: 'أضيفي إلى السلة', choose: 'اختاري الخيارات', added: 'تمت الإضافة', del: 'إزالة' }
    : { add: 'Add to wishlist', remove: 'Remove from wishlist', wishlist: 'Wishlist', empty: 'Your wishlist is empty. Tap the heart on any product to save it here.', shop: 'Shop now', cart: 'Add to cart', choose: 'Choose options', added: 'Added', del: 'Remove' };
  var HEART = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M10 16.9 3.1 10.1C1.3 8.3 1.3 5.4 3.1 3.6c1.7-1.7 4.4-1.7 6.1 0l.8.8.8-.8c1.7-1.7 4.4-1.7 6.1 0 1.8 1.8 1.8 4.7 0 6.5L10 16.9Z" fill="none" stroke="currentColor" stroke-width="var(--icon-stroke-width, 1.5)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); write(a); sync(); return i === -1; }
  function handleOf(card) { var a = card.querySelector('a[href*="/products/"]'); if (!a) return null; var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function sync() {
    var n = read().length;
    document.querySelectorAll('.sharq-wish-count').forEach(function (el) { var t = n ? String(n) : ''; if (el.textContent !== t) el.textContent = t; if (el.hidden !== !n) el.hidden = !n; });
    document.querySelectorAll('.sharq-wish[data-handle]').forEach(function (b) {
      var on = has(b.dataset.handle); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? T.remove : T.add);
    });
  }
  function decorate(root) {
    (root || document).querySelectorAll('product-card .card-gallery').forEach(function (g) {
      if (g.querySelector('.sharq-wish')) return;
      var card = g.closest('product-card'), h = handleOf(card); if (!h) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sharq-wish'; b.dataset.handle = h; b.innerHTML = HEART;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(h); });
      g.appendChild(b);
    });
    sync();
  }
  function headerLink() {
    var actions = document.querySelector('header-actions'); if (!actions || actions.querySelector('.sharq-wish-link')) return;
    var a = document.createElement('a'); a.className = 'sharq-wish-link header-actions__action'; a.href = '/pages/wishlist'; a.setAttribute('aria-label', T.wishlist);
    a.innerHTML = HEART + '<span class="sharq-wish-count" hidden></span>';
    actions.insertBefore(a, actions.lastElementChild);
    sync();
  }
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return cur + ' ' + (c / 100).toFixed(2); }
  }
  function page() {
    var box = document.getElementById('sharq-wishlist'); if (!box) return;
    var hs = read();
    if (!hs.length) { box.innerHTML = '<div class="sharq-wish-empty"><p>' + T.empty + '</p><a class="button" href="/collections/all">' + T.shop + '</a></div>'; return; }
    box.innerHTML = '<div class="sharq-wish-grid"></div>'; var grid = box.firstChild;
    hs.forEach(function (h) {
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var multi = p.variants.length > 1, v = p.variants[0], sale = p.compare_at_price > p.price;
        var el = document.createElement('div'); el.className = 'sharq-wish-card';
        el.innerHTML = '<a class="sharq-wish-img" href="' + p.url + '"><img src="' + (p.featured_image || '') + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy"></a>' +
          '<button type="button" class="sharq-wish is-active" data-handle="' + h + '" aria-label="' + T.remove + '">' + HEART + '</button>' +
          '<a class="sharq-wish-title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="sharq-wish-price">' + money(p.price) + (sale ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</div>' +
          (multi ? '<a class="button" href="' + p.url + '">' + T.choose + '</a>' : '<button type="button" class="button sharq-wish-add" data-id="' + v.id + '">' + T.cart + '</button>');
        el.querySelector('.sharq-wish').addEventListener('click', function () { toggle(h); el.remove(); if (!read().length) page(); });
        var add = el.querySelector('.sharq-wish-add');
        if (add) add.addEventListener('click', function () {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
            .then(function () { add.textContent = T.added; document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(function () { location.reload(); }, 600); });
        });
        grid.appendChild(el);
      });
    });
  }
  function init() { decorate(); headerLink(); page(); var pending = false; new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; decorate(); headerLink(); }, 150); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('storage', sync);
})();


/* ===== Product page: turn the Colour option into colour circles with a tooltip ===== */
(function () {
  var HEX = { Black: '#1c1a17', Sand: '#cdb89a', Mocha: '#6b4f3f', Ivory: '#efe7d8', Charcoal: '#3b3a3a', Taupe: '#8a7b6d', Olive: '#6b6a45', Navy: '#1e2a44', Champagne: '#d9c3a0', Sage: '#a3b09a', 'Dusty Rose': '#d9aaa3', Emerald: '#1f5a45', Burgundy: '#6b1f2e', 'Midnight Navy': '#17213a', 'Sky Blue': '#a9c4d9', Blush: '#eac9c4' };
  function run() {
    document.querySelectorAll('fieldset.variant-option').forEach(function (f) {
      var lg = f.querySelector('legend');
      var opt = f.querySelector('input[data-option-name]');
      var name = (opt && opt.getAttribute('data-option-name')) || (lg && lg.textContent) || '';
      if (!/colou?r|لون/i.test(name)) return;
      f.classList.add('sharq-color-option');
      f.querySelectorAll('label.variant-option__button-label').forEach(function (l) {
        var i = l.querySelector('input'); if (!i) return;
        var v = i.value;
        if (l.style.getPropertyValue('--swatch') !== (HEX[v] || '#c9c2b4')) l.style.setProperty('--swatch', HEX[v] || '#c9c2b4');
        if (!l.querySelector('.sharq-tip')) { var t = document.createElement('span'); t.className = 'sharq-tip'; t.textContent = v; l.appendChild(t); }
      });
    });
  }
  // Run synchronously inside the observer (a microtask) so a re-rendered picker is restyled before the browser paints — no flash.
  function init() { run(); new MutationObserver(function () { run(); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== Announcement bar -> continuous ticker (pauses on hover) ===== */
(function () {
  function build() {
    var bar = document.querySelector('announcement-bar-component');
    if (!bar || bar.dataset.sharqTicker) return;
    var texts = Array.prototype.map.call(bar.querySelectorAll('slideshow-slide'), function (s) { return s.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (!texts.length) return;
    bar.dataset.sharqTicker = '1';
    var wrap = document.createElement('div'); wrap.className = 'sharq-ticker';
    var track = document.createElement('div'); track.className = 'sharq-ticker__track';
    function group(hidden) {
      var g = document.createElement('div'); g.className = 'sharq-ticker__group'; if (hidden) g.setAttribute('aria-hidden', 'true');
      for (var r = 0; r < 3; r++) texts.forEach(function (t) {
        var i = document.createElement('span'); i.className = 'sharq-ticker__item'; i.textContent = t; g.appendChild(i);
        var d = document.createElement('span'); d.className = 'sharq-ticker__dot'; d.setAttribute('aria-hidden', 'true'); g.appendChild(d);
      });
      return g;
    }
    track.appendChild(group(false)); track.appendChild(group(true)); wrap.appendChild(track); bar.appendChild(wrap);
    bar.classList.add('sharq-ticker-on');
    try { var s = bar.querySelector('.announcement-bar__slides'); if (s) s.setAttribute('aria-hidden', 'true'); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();

/* ===== Empty cart drawer: "Continue shopping" closes the drawer, then opens All products ===== */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a.cart-items__empty-button');
  if (!a) return;
  var dlg = a.closest('dialog');
  if (!dlg) return; // on the /cart page itself the normal link is fine
  e.preventDefault(); e.stopPropagation();
  var drawer = dlg.closest('theme-drawer');
  try { if (drawer && typeof drawer.close === 'function') drawer.close(); else if (dlg.open) dlg.close(); } catch (_) {}
  var target = '/collections/all';
  if (location.pathname.replace(/\/$/, '') !== target) setTimeout(function () { location.href = target; }, 380);
}, true);

/* ===== Price filter fallback =====
   Shopify's built-in price filter only works in the store currency. In converted currencies (SAR, USD, CAD...) it disappears,
   so we add an identical-looking Price panel that filters the products on the page by their displayed price. */
(function () {
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var T = AR ? { price: 'السعر', to: 'إلى', low: 'أدنى سعر', high: 'أعلى سعر', highest: 'أعلى سعر هو', clear: 'مسح' }
             : { price: 'Price', to: 'to', low: 'Low price', high: 'High price', highest: 'The highest price is', clear: 'Clear' };
  var state = { min: null, max: null };
  function lang() { return document.documentElement.lang || 'en'; }
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED'; }
  function symbol() { try { var p = new Intl.NumberFormat(lang(), { style: 'currency', currency: cur() }).formatToParts(0); for (var i = 0; i < p.length; i++) if (p[i].type === 'currency') return p[i].value; } catch (e) {} return cur(); }
  function money(n) { try { return new Intl.NumberFormat(lang(), { style: 'currency', currency: cur(), maximumFractionDigits: 0 }).format(n); } catch (e) { return String(n); } }
  function norm(s) { return s.replace(/[٠-٩]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); }).replace(/٬/g, ',').replace(/٫/g, '.'); }
  function priceOf(item) { var pp = item.querySelector('product-price'); if (!pp) return null; var m = norm(pp.textContent.replace(/\s+/g, ' ')).match(/\d[\d,]*(?:\.\d+)?/); return m ? parseFloat(m[0].replace(/,/g, '')) : null; }
  function items() { return Array.prototype.slice.call(document.querySelectorAll('.product-grid__item')); }
  function maxPrice() { var m = 0; items().forEach(function (i) { var p = priceOf(i); if (p && p > m) m = p; }); return Math.ceil(m); }
  function countEl() {
    var els = document.querySelectorAll('main *'); for (var i = 0; i < els.length; i++) { var e = els[i]; if (e.children.length === 0 && /^\s*\d+\s+(items?|products?|منتج|منتجات)\s*$/i.test(e.textContent) && e.getBoundingClientRect().width > 0) return e; } return null;
  }
  function apply() {
    var shown = 0, any = state.min != null || state.max != null;
    items().forEach(function (it) {
      var p = priceOf(it); var hide = any && p != null && ((state.min != null && p < state.min) || (state.max != null && p > state.max));
      if (hide) { if (!it.hasAttribute('data-sharq-hidden')) it.setAttribute('data-sharq-hidden', ''); } else { if (it.hasAttribute('data-sharq-hidden')) it.removeAttribute('data-sharq-hidden'); shown++; }
    });
    var ce = countEl(); if (ce) { var t = ce.textContent.replace(/\d+/, String(shown)); if (ce.textContent !== t) ce.textContent = t; }
    (function () { var roots = document.querySelectorAll('facets-form-component, [class*="facets"]'); roots.forEach(function (r) { var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT, null); var n; while ((n = w.nextNode())) { if (/^\s*(see|view|show)\s+\d+\s+items?\s*$/i.test(n.nodeValue)) { var u = n.nodeValue.replace(/\d+/, String(shown)); if (n.nodeValue !== u) n.nodeValue = u; } } }); })();
  }
  function val(v) { return v == null ? '' : String(v); }
  function parseIn(s) { s = norm(String(s || '')).replace(/[^\d.]/g, ''); return s === '' ? null : parseFloat(s); }
  function syncInputs() { document.querySelectorAll('.sharq-price-item input[data-k]').forEach(function (i) { var v = val(state[i.dataset.k]); if (i.value !== v && document.activeElement !== i) i.value = v; }); document.querySelectorAll('.sharq-price-clear').forEach(function (c) { c.hidden = state.min == null && state.max == null; }); }
  function inject() {
    document.querySelectorAll('.facets__filters-wrapper').forEach(function (w) {
      if (w.querySelector('input[name*="price.gte"]') || w.querySelector('.sharq-price-item')) return;
      var tpl = w.querySelector('accordion-custom.facets__item'); if (!tpl) return;
      var c = tpl.cloneNode(true); c.classList.add('sharq-price-item');
      c.querySelectorAll('*').forEach(function (e) { e.removeAttribute('id'); Array.prototype.slice.call(e.attributes).forEach(function (a) { if (a.name.indexOf('on:') === 0 || a.name === 'ref') e.removeAttribute(a.name); }); });
      var lab = c.querySelector('.facets__label'); if (lab) lab.textContent = T.price;
      var st = c.querySelector('.facets__status'); if (st) st.innerHTML = '';
      var panel = c.querySelector('floating-panel-component, .facets__panel-content'); if (!panel) return;
      var mx = maxPrice(), sym = symbol();
      panel.innerHTML = '<div class="facets__inputs-wrapper facets__inputs-wrapper--row"><div class="price-facet__inputs-wrapper">' +
        '<div class="field price-facet__field"><input class="field__input price-facet__input" data-k="min" type="text" inputmode="decimal" placeholder="0" autocomplete="off" aria-label="' + T.low + '"><label class="field__label price-facet__label">' + sym + '</label></div>' +
        '<div class="price-facet__separator">' + T.to + '</div>' +
        '<div class="field price-facet__field"><input class="field__input price-facet__input" data-k="max" type="text" inputmode="decimal" placeholder="' + mx + '" autocomplete="off" aria-label="' + T.high + '"><label class="field__label price-facet__label">' + sym + '</label></div>' +
        '</div></div><div class="price-facet__highest-price">' + T.highest + ' <bdi>' + money(mx) + '</bdi></div><button type="button" class="sharq-price-clear" hidden>' + T.clear + '</button>';
      var t; panel.querySelectorAll('input[data-k]').forEach(function (i) {
        i.addEventListener('input', function () { state[i.dataset.k] = parseIn(i.value); clearTimeout(t); t = setTimeout(function () { apply(); syncInputs(); }, 250); });
      });
      panel.querySelector('.sharq-price-clear').addEventListener('click', function () { state.min = state.max = null; apply(); syncInputs(); });
      w.appendChild(c);
    });
    syncInputs();
  }
  var pending = false;
  function sync() { if (pending) return; pending = true; setTimeout(function () { pending = false; if (!document.querySelector('.facets__filters-wrapper')) return; inject(); apply(); }, 80); }
  function init() { sync(); new MutationObserver(sync).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== Grid colour dots: swap the card photo in place (standard behaviour), and make the card + quick-add open on that colour ===== */
document.addEventListener('click', function (e) {
  var sw = e.target.closest && e.target.closest('.sharq-swatch');
  if (!sw) return;
  var card = sw.closest('product-card');
  if (!card || !sw.dataset.variantId) return; // no variant data: let the link work normally
  e.preventDefault(); e.stopPropagation();
  card.querySelectorAll('.sharq-swatch').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
  // 1) card links (photo, title, quick-add) now point at this colour's variant
  ['productCardLink', 'cardGalleryLink', 'productTitleLink'].forEach(function (ref) {
    var a = card.querySelector('[ref="' + ref + '"]'); if (!a || !a.getAttribute('href')) return;
    try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', sw.dataset.variantId); a.setAttribute('href', u.pathname + u.search); } catch (_) {}
  });
  // 2) swap the visible photo
  if (sw.dataset.imgLg) {
    var img = card.querySelector('.card-gallery slideshow-slide img, .card-gallery img');
    if (img) {
      img.removeAttribute('data-sharq-original');
      img.src = sw.dataset.imgLg; img.srcset = sw.dataset.imgSm + ' 480w, ' + sw.dataset.imgLg + ' 960w';
      if (sw.dataset.alt) img.alt = sw.dataset.alt;
    }
    card.classList.add('sharq-color-picked');
  }
}, true);
